import { visualizacaoModoList } from '../../../../common/visualizacao-modo';

export class ClienteVisualizacao {
    modo: number;

    constructor() {
        this.modo = visualizacaoModoList.id;
    }
}
